/* eslint-disable */
export function addClass(elem, className) {
  if (elem.className.indexOf(className) === -1) {
    elem.className += className;
  }
}

function hasClass(ele, cls) {
  return ele.className.match(new RegExp('(\\\\s|^)' + cls + '(\\\\s|$)'));
}

export function removeClass(elem, name) {
  if (!hasClass(elem, name)) {
    elem.className = elem.className
      .replace(new RegExp('(\\s|^)' + name + '(\\s|$)'), ' ')
      .replace(/^\s+|\s+$/g, '');
  }
}
